import { useMemo } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PayrollConceptsForBaseSalaryTypeDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface Props {
  deBaseSalaryTypeId?: string | null
}

const BaseSalaryType = ({ deBaseSalaryTypeId }: Props) => {
  const { company } = useCurrentSession()

  const { data } = useQuery(PayrollConceptsForBaseSalaryTypeDocument, {
    variables: { companyId: company.id },
  })

  const label = useMemo(() => {
    if (!deBaseSalaryTypeId) return i18n.t('contract_versions.compensation.not_informed')

    const concepts = data?.payroll.conceptsConnection.nodes || []
    const concept = concepts.find((c) => c.id === deBaseSalaryTypeId)

    return concept?.label || i18n.t('contract_versions.compensation.not_informed')
  }, [deBaseSalaryTypeId, data])

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.compensation.base_salary_type.title')}
      </Text>
      <Text size="300" weight="medium" color="grey1000">
        {label}
      </Text>
    </Box>
  )
}

export default BaseSalaryType
